// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import flagSV from '../../../assets/img/flagsCountry/flag-SV.png';
// @ts-ignore
import flagGQ from '../../../assets/img/flagsCountry/flag-GQ.png';
// @ts-ignore
import flagER from '../../../assets/img/flagsCountry/flag-ER.png';
// @ts-ignore
import flagEE from '../../../assets/img/flagsCountry/flag-EE.png';
// @ts-ignore
import flagET from '../../../assets/img/flagsCountry/flag-ET.png';
// @ts-ignore
import flagFK from '../../../assets/img/flagsCountry/flag-FK.png';
// @ts-ignore
import flagFO from '../../../assets/img/flagsCountry/flag-FO.png';
// @ts-ignore
import flagFJ from '../../../assets/img/flagsCountry/flag-FJ.png';
// @ts-ignore
import flagFI from '../../../assets/img/flagsCountry/flag-FI.png';
// @ts-ignore
import flagFR from '../../../assets/img/flagsCountry/flag-FR.png';
// @ts-ignore
import flagGF from '../../../assets/img/flagsCountry/flag-GF.png';
// @ts-ignore
import flagPF from '../../../assets/img/flagsCountry/flag-PF.png';
// @ts-ignore
import flagGA from '../../../assets/img/flagsCountry/flag-GA.png';
// @ts-ignore
import flagGM from '../../../assets/img/flagsCountry/flag-GM.png';
// @ts-ignore
import flagGE from '../../../assets/img/flagsCountry/flag-GE.png';
// @ts-ignore
import flagDE from '../../../assets/img/flagsCountry/flag-DE.png';
// @ts-ignore
import flagGH from '../../../assets/img/flagsCountry/flag-GH.png';
// @ts-ignore
import flagGI from '../../../assets/img/flagsCountry/flag-GI.png';
// @ts-ignore
import flagGR from '../../../assets/img/flagsCountry/flag-GR.png';
// @ts-ignore
import flagGL from '../../../assets/img/flagsCountry/flag-GL.png';
// @ts-ignore
import flagGD from '../../../assets/img/flagsCountry/flag-GD.png';
// @ts-ignore
import flagGP from '../../../assets/img/flagsCountry/flag-GP.png';
// @ts-ignore
import flagGU from '../../../assets/img/flagsCountry/flag-GU.png';
// @ts-ignore
import flagGT from '../../../assets/img/flagsCountry/flag-GT.png';
// @ts-ignore
import flagGG from '../../../assets/img/flagsCountry/flag-GG.png';
// @ts-ignore
import flagGN from '../../../assets/img/flagsCountry/flag-GN.png';
// @ts-ignore
import flagGW from '../../../assets/img/flagsCountry/flag-GW.png';
// @ts-ignore
import flagGY from '../../../assets/img/flagsCountry/flag-GY.png';
// @ts-ignore
import flagHT from '../../../assets/img/flagsCountry/flag-HT.png';
// @ts-ignore
import flagHN from '../../../assets/img/flagsCountry/flag-HN.png';
// @ts-ignore
import flagHK from '../../../assets/img/flagsCountry/flag-HK.png';
// @ts-ignore
import flagHU from '../../../assets/img/flagsCountry/flag-HU.png';
// @ts-ignore
import flagIS from '../../../assets/img/flagsCountry/flag-IS.png';
// @ts-ignore
import flagIN from '../../../assets/img/flagsCountry/flag-IN.png';
// @ts-ignore
import flagID from '../../../assets/img/flagsCountry/flag-ID.png';
// @ts-ignore
import flagIR from '../../../assets/img/flagsCountry/flag-IR.png';
// @ts-ignore
import flagIQ from '../../../assets/img/flagsCountry/flag-IQ.png';
// @ts-ignore
import flagIE from '../../../assets/img/flagsCountry/flag-IE.png';
// @ts-ignore
import flagIM from '../../../assets/img/flagsCountry/flag-IM.png';
// @ts-ignore
import flagIL from '../../../assets/img/flagsCountry/flag-IL.png';
// @ts-ignore
import flagIT from '../../../assets/img/flagsCountry/flag-IT.png';
// @ts-ignore
import flagJM from '../../../assets/img/flagsCountry/flag-JM.png';
// @ts-ignore
import flagJP from '../../../assets/img/flagsCountry/flag-JP.png';
// @ts-ignore
import flagJE from '../../../assets/img/flagsCountry/flag-JE.png';
// @ts-ignore
import flagJO from '../../../assets/img/flagsCountry/flag-JO.png';
// @ts-ignore
import flagKZ from '../../../assets/img/flagsCountry/flag-KZ.png';
// @ts-ignore
import flagKE from '../../../assets/img/flagsCountry/flag-KE.png';
// @ts-ignore
import flagKI from '../../../assets/img/flagsCountry/flag-KI.png';
// @ts-ignore
import flagKP from '../../../assets/img/flagsCountry/flag-KP.png';
// @ts-ignore
import flagKR from '../../../assets/img/flagsCountry/flag-KR.png';
// @ts-ignore
import flagXK from '../../../assets/img/flagsCountry/flag-XK.png';
// @ts-ignore
import flagKW from '../../../assets/img/flagsCountry/flag-KW.png';
// @ts-ignore
import flagKG from '../../../assets/img/flagsCountry/flag-KG.png';
// @ts-ignore
import flagLA from '../../../assets/img/flagsCountry/flag-LA.png';
// @ts-ignore
import flagLV from '../../../assets/img/flagsCountry/flag-LV.png';
// @ts-ignore
import flagLB from '../../../assets/img/flagsCountry/flag-LB.png';
// @ts-ignore
import flagLS from '../../../assets/img/flagsCountry/flag-LS.png';
// @ts-ignore
import flagLR from '../../../assets/img/flagsCountry/flag-LR.png';
// @ts-ignore
import flagLY from '../../../assets/img/flagsCountry/flag-LY.png';
// @ts-ignore
import flagLI from '../../../assets/img/flagsCountry/flag-LI.png';
// @ts-ignore
import flagLT from '../../../assets/img/flagsCountry/flag-LT.png';
// @ts-ignore
import flagLU from '../../../assets/img/flagsCountry/flag-LU.png';
const CountriesB = [
    {
        ru: 'Сальвадор',
        lt: 'Salvadoras',
        tr: 'El Salvador',
        en: 'El Salvador',
        flagIcon: '🇸🇻',
        code: 'SV',
        flag: flagSV,
        dialCode: '503',
        mask: '9999 9999',
    },
    {
        ru: 'Экваториальная Гвинея',
        lt: 'Pusiaujo Gvinėja',
        tr: 'Ekvator Ginesi',
        en: 'Equatorial Guinea',
        flagIcon: '🇬🇶',
        code: 'GQ',
        flag: flagGQ,
        dialCode: '240',
        mask: '999 999 999',
    },
    {
        ru: 'Эритрея',
        lt: 'Eritrėja',
        tr: 'Eritre',
        en: 'Eritrea',
        flagIcon: '🇪🇷',
        code: 'ER',
        flag: flagER,
        dialCode: '291',
        mask: '99 999 999',
    },
    {
        ru: 'Эстония',
        lt: 'Estija',
        tr: 'Estonya',
        en: 'Estonia',
        flagIcon: '🇪🇪',
        code: 'EE',
        flag: flagEE,
        dialCode: '372',
        mask: '9999 9999',
    },
    {
        ru: 'Эфиопия',
        lt: 'Etiopija',
        tr: 'Etiyopya',
        en: 'Ethiopia',
        flagIcon: '🇪🇹',
        code: 'ET',
        flag: flagET,
        dialCode: '251',
        mask: '999 999 9999',
    },
    {
        ru: 'Фолклендские (Мальвинские) острова',
        lt: 'Folklando salos (Malvinai)',
        tr: 'Falkland Adaları (Malvinas)',
        en: 'Falkland Islands (Malvinas)',
        flagIcon: '🇫🇰',
        code: 'FK',
        flag: flagFK,
        dialCode: '500',
        mask: '99999',
    },
    {
        ru: 'Фарерские острова',
        lt: 'Farerų salos',
        tr: 'Faroe Adaları',
        en: 'Faroe Islands',
        flagIcon: '🇫🇴',
        code: 'FO',
        flag: flagFO,
        dialCode: '298',
        mask: '999999',
    },
    {
        ru: 'Фиджи',
        lt: 'Fidžis',
        tr: 'Fiji',
        en: 'Fiji',
        flagIcon: '🇫🇯',
        code: 'FJ',
        flag: flagFJ,
        dialCode: '679',
        mask: '999 9999',
    },
    {
        ru: 'Финляндия',
        lt: 'Suomija',
        tr: 'Finlandiya',
        en: 'Finland',
        flagIcon: '🇫🇮',
        code: 'FI',
        flag: flagFI,
        dialCode: '358',
        mask: '999 9999999',
    },
    {
        ru: 'Франция',
        lt: 'Prancūzijoje',
        tr: 'Fransa',
        en: 'France',
        flagIcon: '🇫🇷',
        code: 'FR',
        flag: flagFR,
        dialCode: '33',
        mask: '99 99 99 99 99',
    },
    {
        ru: 'Французская Гвиана',
        lt: 'Prancūzijos Gviana',
        tr: 'Fransız Guyanası',
        en: 'French Guiana',
        flagIcon: '🇬🇫',
        code: 'GF',
        flag: flagGF,
        dialCode: '594',
        mask: '9999 99 99 99',
    },
    {
        ru: 'Французская Полинезия',
        lt: 'Prancūzų Polinezija',
        tr: 'Fransız Polinezyası',
        en: 'French Polynesia',
        flagIcon: '🇵🇫',
        code: 'PF',
        flag: flagPF,
        dialCode: '689',
        mask: '99 99 99 99',
    },
    {
        ru: 'Габон',
        lt: 'Gabonas',
        tr: 'Gabon',
        en: 'Gabon',
        flagIcon: '🇬🇦',
        code: 'GA',
        flag: flagGA,
        dialCode: '241',
        mask: '99 99 99 99',
    },
    {
        ru: 'Гамбия',
        lt: 'Gambija',
        tr: 'Gambiya',
        en: 'Gambia',
        flagIcon: '🇬🇲',
        code: 'GM',
        flag: flagGM,
        dialCode: '220',
        mask: '999 9999',
    },
    {
        ru: 'Грузия',
        lt: 'Gruzijoje',
        tr: 'Gürcistan',
        en: 'Georgia',
        flagIcon: '🇬🇪',
        code: 'GE',
        flag: flagGE,
        dialCode: '995',
        mask: '999 99 99 99',
    },
    {
        ru: 'Германия',
        lt: 'Vokietija',
        tr: 'Almanya',
        en: 'Germany',
        flagIcon: '🇩🇪',
        code: 'DE',
        flag: flagDE,
        dialCode: '49',
        mask: '99999 9999999',
    },
    {
        ru: 'Гана',
        lt: 'Gana',
        tr: 'Gana',
        en: 'Ghana',
        flagIcon: '🇬🇭',
        code: 'GH',
        flag: flagGH,
        dialCode: '233',
        mask: '999 999 9999',
    },
    {
        ru: 'Гибралтар',
        lt: 'Gibraltaras',
        tr: 'Cebelitarık',
        en: 'Gibraltar',
        flagIcon: '🇬🇮',
        code: 'GI',
        flag: flagGI,
        dialCode: '350',
        mask: '99999999',
    },
    {
        ru: 'Греция',
        lt: 'Graikija',
        tr: 'Yunanistan',
        en: 'Greece',
        flagIcon: '🇬🇷',
        code: 'GR',
        flag: flagGR,
        dialCode: '30',
        mask: '999 999 9999',
    },
    {
        ru: 'Гренландия',
        lt: 'Grenlandija',
        tr: 'Grönland',
        en: 'Greenland',
        flagIcon: '🇬🇱',
        code: 'GL',
        flag: flagGL,
        dialCode: '299',
        mask: '99 99 99',
    },
    {
        ru: 'Гренада',
        lt: 'Grenada',
        tr: 'Grenada',
        en: 'Grenada',
        flagIcon: '🇬🇩',
        code: 'GD',
        flag: flagGD,
        dialCode: '1473',
        mask: '(999) 999-9999',
    },
    {
        ru: 'Гваделупа',
        lt: 'Gvadelupa',
        tr: 'Guadeloupe',
        en: 'Guadeloupe',
        flagIcon: '🇬🇵',
        code: 'GP',
        flag: flagGP,
        dialCode: '590',
        mask: '9999 99 99 99',
    },
    {
        ru: 'Гуам',
        lt: 'Guamas',
        tr: 'Guam',
        en: 'Guam',
        flagIcon: '🇬🇺',
        code: 'GU',
        flag: flagGU,
        dialCode: '1671',
        mask: '(999) 999-9999',
    },
    {
        ru: 'Гватемала',
        lt: 'Gvatemala',
        tr: 'Guatemala',
        en: 'Guatemala',
        flagIcon: '🇬🇹',
        code: 'GT',
        flag: flagGT,
        dialCode: '502',
        mask: '9999 9999',
    },
    {
        ru: 'шерстяная фуфайка',
        lt: 'Gernsis',
        tr: 'bir tür inek',
        en: 'Guernsey',
        flagIcon: '🇬🇬',
        code: 'GG',
        flag: flagGG,
        dialCode: '44',
        mask: '99999 999999',
    },
    {
        ru: 'Гвинея',
        lt: 'Gvinėjos',
        tr: 'Gine',
        en: 'Guinea',
        flagIcon: '🇬🇳',
        code: 'GN',
        flag: flagGN,
        dialCode: '224',
        mask: '999 99 99 99',
    },
    {
        ru: 'Гвинея-Бисау',
        lt: 'Bisau Gvinėja',
        tr: 'Gine-Bissau',
        en: 'Guinea-Bissau',
        flagIcon: '🇬🇼',
        code: 'GW',
        flag: flagGW,
        dialCode: '245',
        mask: '999 999 999',
    },
    {
        ru: 'Гайана',
        lt: 'Gajana',
        tr: 'Guyana',
        en: 'Guyana',
        flagIcon: '🇬🇾',
        code: 'GY',
        flag: flagGY,
        dialCode: '592',
        mask: '999 9999',
    },
    {
        ru: 'Гаити',
        lt: 'Haitis',
        tr: 'Haiti',
        en: 'Haiti',
        flagIcon: '🇭🇹',
        code: 'HT',
        flag: flagHT,
        dialCode: '509',
        mask: '99 99 9999',
    },
    {
        ru: 'Гондурас',
        lt: 'Hondūras',
        tr: 'Honduras',
        en: 'Honduras',
        flagIcon: '🇭🇳',
        code: 'HN',
        flag: flagHN,
        dialCode: '504',
        mask: '9999-9999',
    },
    {
        ru: 'Гонконг',
        lt: 'Honkongas',
        tr: 'Hong Kong',
        en: 'Hong Kong',
        flagIcon: '🇭🇰',
        code: 'HK',
        flag: flagHK,
        dialCode: '852',
        mask: '9999 9999',
    },
    {
        ru: 'Венгрия',
        lt: 'Vengrija',
        tr: 'Macaristan',
        en: 'Hungary',
        flagIcon: '🇭🇺',
        code: 'HU',
        flag: flagHU,
        dialCode: '36',
        mask: '(99) 999 9999',
    },
    {
        ru: 'Исландия',
        lt: 'Islandija',
        tr: 'İzlanda',
        en: 'Iceland',
        flagIcon: '🇮🇸',
        code: 'IS',
        flag: flagIS,
        dialCode: '354',
        mask: '999 9999',
    },
    {
        ru: 'Индия',
        lt: 'Indija',
        tr: 'Hindistan',
        en: 'India',
        flagIcon: '🇮🇳',
        code: 'IN',
        flag: flagIN,
        dialCode: '91',
        mask: '99999 99999',
    },
    {
        ru: 'Индонезия',
        lt: 'Indonezija',
        tr: 'Endonezya',
        en: 'Indonesia',
        flagIcon: '🇮🇩',
        code: 'ID',
        flag: flagID,
        dialCode: '62',
        mask: '9999-999-999',
    },
    {
        ru: 'Иран, Исламская Республика Персидского залива',
        lt: 'Iranas, Persijos įlankos Islamo Respublika',
        tr: 'İran, Basra Körfezi İslam Cumhuriyeti',
        en: 'Iran, Islamic Republic of Persian Gulf',
        flagIcon: '🇮🇷',
        code: 'IR',
        flag: flagIR,
        dialCode: '98',
        mask: '9999 999 9999',
    },
    {
        ru: 'Ирак',
        lt: 'Irakas',
        tr: 'Irak',
        en: 'Iraq',
        flagIcon: '🇮🇶',
        code: 'IQ',
        flag: flagIQ,
        dialCode: '964',
        mask: '9999 999 9999',
    },
    {
        ru: 'Ирландия',
        lt: 'Airija',
        tr: 'İrlanda',
        en: 'Ireland',
        flagIcon: '🇮🇪',
        code: 'IE',
        flag: flagIE,
        dialCode: '353',
        mask: '999 999 9999',
    },
    {
        ru: 'Остров Мэн',
        lt: 'Meno sala',
        tr: 'Man Adası',
        en: 'Isle of Man',
        flagIcon: '🇮🇲',
        code: 'IM',
        flag: flagIM,
        dialCode: '44',
        mask: '99999 999999',
    },
    {
        ru: 'Израиль',
        lt: 'Izraelis',
        tr: 'İsrail',
        en: 'Israel',
        flagIcon: '🇮🇱',
        code: 'IL',
        flag: flagIL,
        dialCode: '972',
        mask: '999-999-9999',
    },
    {
        ru: 'Италия',
        lt: 'Italijoje',
        tr: 'İtalya',
        en: 'Italy',
        flagIcon: '🇮🇹',
        code: 'IT',
        flag: flagIT,
        dialCode: '39',
        mask: '999 999 9999',
    },
    {
        ru: 'Ямайка',
        lt: 'Jamaika',
        tr: 'Jamaika',
        en: 'Jamaica',
        flagIcon: '🇯🇲',
        code: 'JM',
        flag: flagJM,
        dialCode: '1876',
        mask: '(999) 999-9999',
    },
    {
        ru: 'Япония',
        lt: 'Japonija',
        tr: 'Japonya',
        en: 'Japan',
        flagIcon: '🇯🇵',
        code: 'JP',
        flag: flagJP,
        dialCode: '81',
        mask: '999-9999-9999',
    },
    {
        ru: 'Джерси',
        lt: 'Džersis',
        tr: 'Jersey',
        en: 'Jersey',
        flagIcon: '🇯🇪',
        code: 'JE',
        flag: flagJE,
        dialCode: '44',
        mask: '99999 999999',
    },
    {
        ru: 'Иордания',
        lt: 'Jordanija',
        tr: 'Ürdün',
        en: 'Jordan',
        flagIcon: '🇯🇴',
        code: 'JO',
        flag: flagJO,
        dialCode: '962',
        mask: '99 9999 9999',
    },
    {
        ru: 'Казахстан',
        lt: 'Kazachstanas',
        tr: 'Kazakistan',
        en: 'Kazakhstan',
        flagIcon: '🇰🇿',
        code: 'KZ',
        flag: flagKZ,
        dialCode: '7',
        mask: '9 (999) 999 9999',
    },
    {
        ru: 'Кения',
        lt: 'Kenija',
        tr: 'Kenya',
        en: 'Kenya',
        flagIcon: '🇰🇪',
        code: 'KE',
        flag: flagKE,
        dialCode: '254',
        mask: '9999 999999',
    },
    {
        ru: 'Кирибати',
        lt: 'Kiribatis',
        tr: 'Kiribati',
        en: 'Kiribati',
        flagIcon: '🇰🇮',
        code: 'KI',
        flag: flagKI,
        dialCode: '686',
        mask: '99999999',
    },
    {
        ru: 'Корея, Корейская Народно-Демократическая Республика',
        lt: 'Korėja, Korėjos Liaudies Demokratinė Respublika',
        tr: 'Kore, Kore Demokratik Halk Cumhuriyeti',
        en: "Korea, Democratic People's Republic of Korea",
        flagIcon: '🇰🇵',
        code: 'KP',
        flag: flagKP,
        dialCode: '850',
        mask: '(9) 99999',
    },
    {
        ru: 'Корея, Республика Южная Корея',
        lt: 'Korėja, Pietų Korėjos Respublika',
        tr: 'Güney Kore Cumhuriyeti',
        en: 'Korea, Republic of South Korea',
        flagIcon: '🇰🇷',
        code: 'KR',
        flag: flagKR,
        dialCode: '82',
        mask: '999-9999-9999',
    },
    {
        ru: 'Косово',
        lt: 'Kosovas',
        tr: 'Kosova',
        en: 'Kosovo',
        flagIcon: '🇽🇰',
        code: 'XK',
        flag: flagXK,
        dialCode: '383',
        mask: '999 999 999',
    },
    {
        ru: 'Кувейт',
        lt: 'Kuveitas',
        tr: 'Kuveyt',
        en: 'Kuwait',
        flagIcon: '🇰🇼',
        code: 'KW',
        flag: flagKW,
        dialCode: '965',
        mask: '999 99999',
    },
    {
        ru: 'Киргизия',
        lt: 'Kirgizija',
        tr: 'Kırgızistan',
        en: 'Kyrgyzstan',
        flagIcon: '🇰🇬',
        code: 'KG',
        flag: flagKG,
        dialCode: '996',
        mask: '9999 999 999',
    },
    {
        ru: 'Лаос',
        lt: 'Laosas',
        tr: 'Laos',
        en: 'Laos',
        flagIcon: '🇱🇦',
        code: 'LA',
        flag: flagLA,
        dialCode: '856',
        mask: '999 99 999 999',
    },
    {
        ru: 'Латвия',
        lt: 'Latvijoje',
        tr: 'Letonya',
        en: 'Latvia',
        flagIcon: '🇱🇻',
        code: 'LV',
        flag: flagLV,
        dialCode: '371',
        mask: '99 999 999',
    },
    {
        ru: 'Ливан',
        lt: 'Libanas',
        tr: 'Lübnan',
        en: 'Lebanon',
        flagIcon: '🇱🇧',
        code: 'LB',
        flag: flagLB,
        dialCode: '961',
        mask: '99 999 999',
    },
    {
        ru: 'Лесото',
        lt: 'Lesotas',
        tr: 'Lesotho',
        en: 'Lesotho',
        flagIcon: '🇱🇸',
        code: 'LS',
        flag: flagLS,
        dialCode: '266',
        mask: '9999 9999',
    },
    {
        ru: 'Либерия',
        lt: 'Liberija',
        tr: 'Liberya',
        en: 'Liberia',
        flagIcon: '🇱🇷',
        code: 'LR',
        flag: flagLR,
        dialCode: '231',
        mask: '999 999 9999',
    },
    {
        ru: 'Ливийская арабская джамахирия',
        lt: 'Libijos arabų Jamahiriya',
        tr: 'Libya Arap Jamahiriya',
        en: 'Libyan Arab Jamahiriya',
        flagIcon: '🇱🇾',
        code: 'LY',
        flag: flagLY,
        dialCode: '218',
        mask: '999-9999999',
    },
    {
        ru: 'Лихтенштейн',
        lt: 'Lichtenšteinas',
        tr: 'Lihtenştayn',
        en: 'Liechtenstein',
        flagIcon: '🇱🇮',
        code: 'LI',
        flag: flagLI,
        dialCode: '423',
        mask: '999 999 999',
    },
    {
        ru: 'Литва',
        lt: 'Lietuva',
        tr: 'Litvanya',
        en: 'Lithuania',
        flagIcon: '🇱🇹',
        code: 'LT',
        flag: flagLT,
        dialCode: '370',
        mask: '(9-999) 9999',
    },
    {
        ru: 'Люксембург',
        lt: 'Liuksemburgas',
        tr: 'Lüksemburg',
        en: 'Luxembourg',
        flagIcon: '🇱🇺',
        code: 'LU',
        flag: flagLU,
        dialCode: '352',
        mask: '999 999 999',
    },
];
export default CountriesB;
